module.exports = __webpack_public_path__ + "img/Groupe 68.b8349371.svg";